// Cache buster version - increment when static assets are updated
const CACHE_BUSTER_VERSION = 2;

// Video URL helper for production CloudFront or local development
export const getVideoUrl = videoFilename => {
    const cacheBuster = CACHE_BUSTER_VERSION;

    // Check if we're in production and should use CloudFront
    if (process.env.NODE_ENV === 'production') {
        return `${process.env.REACT_APP_CDN_URL}/img/_captions/${videoFilename}?v=${cacheBuster}`;
    }

    // Development: use local files
    return `/img/${videoFilename}?v=${cacheBuster}`;
};

// Image URL helper for production CloudFront or local development
export const getImageUrl = imagePath => {
    const cacheBuster = CACHE_BUSTER_VERSION;

    // Remove leading slash if present for consistency
    const cleanPath = imagePath.startsWith('/')
        ? imagePath.slice(1)
        : imagePath;

    // Check if we're in production and should use CloudFront
    if (process.env.NODE_ENV === 'production') {
        return `${process.env.REACT_APP_CDN_URL}/img/_captions/${cleanPath}?v=${cacheBuster}`;
    }

    // Development: use local files
    return `/img/${cleanPath}?v=${cacheBuster}`;
};

// Helper function to get optimized video props
export const getVideoProps = (videoFilename, options = {}) => {
    return {
        src: getVideoUrl(videoFilename),
        preload: options.preload || 'metadata',
        playsInline: true,
        muted: options.muted !== false,
        controls: options.controls || false,
        autoPlay: options.autoPlay || false,
        loop: options.loop || false,
        crossOrigin: 'anonymous',
        ...options,
    };
};

// Helper for CSS mask/background properties (works in styled-components)
export const getCSSImageUrl = imagePath => {
    const cacheBuster = CACHE_BUSTER_VERSION;

    // Remove leading slash if present for consistency
    let cleanPath = imagePath.startsWith('/')
        ? imagePath.slice(1)
        : imagePath;

    // Check if we're in production and should use CloudFront
    if (process.env.NODE_ENV === 'production') {
        // Remove img/ prefix if present since CDN path already includes it
        const cdnPath = cleanPath.startsWith('img/')
            ? cleanPath.slice(4)
            : cleanPath;
        return `${process.env.REACT_APP_CDN_URL}/img/_captions/${cdnPath}?v=${cacheBuster}`;
    }

    // Development: use local files
    return `/${cleanPath}?v=${cacheBuster}`;
};
